module.exports = __webpack_public_path__ + "static/media/YM55_2.c5cfb107.jpg";